import ShipperOrderCell from './styled';

export default ShipperOrderCell;
